var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { Colors } from "../util/theme";
export var FormButtonType;
(function (FormButtonType) {
    FormButtonType["PRIMARY"] = "primary";
    FormButtonType["SECONDARY"] = "secondary";
    FormButtonType["CANCEL_PRIMARY"] = "cancel-primary";
    FormButtonType["CANCEL_SECONDARY"] = "cancel-secondary";
    FormButtonType["GREEN_PRIMARY"] = "green-primary";
})(FormButtonType || (FormButtonType = {}));
export var FormButton = function (_a) {
    var type = _a.type, title = _a.title, onClick = _a.onClick, isSubmit = _a.isSubmit, isDisabled = _a.isDisabled, isLoading = _a.isLoading;
    var setType = function () {
        switch (type) {
            case FormButtonType.PRIMARY:
                return "contained";
            case FormButtonType.CANCEL_PRIMARY:
                return "contained";
            case FormButtonType.GREEN_PRIMARY:
                return "contained";
            case FormButtonType.SECONDARY:
                return "text";
            case FormButtonType.CANCEL_SECONDARY:
                return "text";
        }
    };
    var setBackground = function () {
        switch (type) {
            case FormButtonType.PRIMARY:
                return Colors.AZUL_GOV;
            case FormButtonType.SECONDARY:
                return "transparent";
            case FormButtonType.CANCEL_SECONDARY:
                return "transparent";
            case FormButtonType.CANCEL_PRIMARY:
                return Colors.VERMELHO_GOV;
            case FormButtonType.GREEN_PRIMARY:
                return Colors.VERDE_GOV;
        }
    };
    var setTextColor = function () {
        switch (type) {
            case FormButtonType.PRIMARY:
                return "white";
            case FormButtonType.CANCEL_PRIMARY:
                return "white";
            case FormButtonType.GREEN_PRIMARY:
                return "white";
            case FormButtonType.SECONDARY:
                return Colors.AZUL_GOV;
            case FormButtonType.CANCEL_SECONDARY:
                return Colors.VERMELHO_GOV;
        }
    };
    return (_jsx(Button, __assign({ type: isSubmit ? "submit" : "button", variant: setType(), disabled: isDisabled, sx: {
            alignSelf: "center",
            backgroundColor: setBackground(),
            color: setTextColor(),
        }, fullWidth: true, onClick: onClick }, { children: isLoading ? _jsx(CircularProgress, {}) : title })));
};
